var _slicedToArray = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/slicedToArray");

var _taggedTemplateLiteral = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

module.exports = function (e) {
  var t = {};

  function n(o) {
    if (t[o]) return t[o].exports;
    var r = t[o] = {
      i: o,
      l: !1,
      exports: {}
    };
    return e[o].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, o) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: o
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var o = Object.create(null);
    if (n.r(o), Object.defineProperty(o, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var r in e) {
      n.d(o, r, function (t) {
        return e[t];
      }.bind(null, r));
    }
    return o;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 48);
}({
  1: function _(e, t) {
    e.exports = require("react");
  },
  2: function _(e, t) {
    e.exports = require("styled-components");
  },
  3: function _(e, t) {
    e.exports = require("../../styles");
  },
  48: function _(e, t, n) {
    "use strict";

    var o = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    },
        r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = o(n(1)),
        l = r(n(2)),
        a = r(n(8)),
        d = n(3),
        u = d.colorPalettes.AldeaPalette;
    t.Title = l.default.p(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n"]))), t.DropdownButton = l.default.div.attrs(function () {
      return {
        className: "dropdown-button"
      };
    })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  border: 0;\n  background-color: transparent;\n  &:focus {\n    outline-width: 0;\n    outline-color: transparent;\n  }\n"]))), t.Indicator = l.default.span.attrs(function () {
      return {
        className: "indicator"
      };
    })(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  margin-left: 5px;\n  &::after {\n    border-style: solid;\n    border-width: 0 3px 3px 0;\n    content: '';\n    display: inline-block;\n    padding: 3px;\n    transition: 0.3s;\n    vertical-align: middle;\n\n    ", "\n  }\n"])), function (_ref) {
      var _ref$color = _ref.color,
          e = _ref$color === void 0 ? u.pink : _ref$color,
          t = _ref.opened;
      return "\n      color: ".concat(e, ";\n      transform: rotate(").concat(t ? "225deg" : "45deg", ");\n    ");
    }), t.Content = l.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: none;\n  position: fixed;\n  z-index: 100000;\n  box-shadow: 0 0 7px 0 rgba(0,0,0,.1);\n  ", "\n  ", "\n  ", "\n"])), function (_ref2) {
      var e = _ref2.opened;
      return e && "display: block;";
    }, function (_ref3) {
      var e = _ref3.y,
          t = _ref3.height,
          n = _ref3.left,
          o = _ref3.contentWidth;
      return "\n    top: ".concat(e + t, "px;\n    width: ").concat(o, "px;\n    left: ").concat(n, "px;\n  ");
    }, function (_ref4) {
      var e = _ref4.styles;
      return e;
    }), t.DropdownContainer = l.default.div.attrs({
      className: "DropdownContainer"
    })(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"]))), t.OverlayButton = l.default.button(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: fixed;\n  background-color: rgba(0,0,0,0.0);\n  bottom: 0;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 100%;\n  width: 100%;\n  z-index: 999;\n  border: none;\n"])));

    t.default = function (_ref5) {
      var _ref5$showIndicator = _ref5.showIndicator,
          e = _ref5$showIndicator === void 0 ? !0 : _ref5$showIndicator,
          _ref5$indicatorColor = _ref5.indicatorColor,
          n = _ref5$indicatorColor === void 0 ? "#444" : _ref5$indicatorColor,
          o = _ref5.title,
          r = _ref5.content,
          l = _ref5.className,
          _ref5$contentWidth = _ref5.contentWidth,
          d = _ref5$contentWidth === void 0 ? 240 : _ref5$contentWidth,
          _ref5$offsetTop = _ref5.offsetTop,
          u = _ref5$offsetTop === void 0 ? 0 : _ref5$offsetTop,
          _ref5$onDismiss = _ref5.onDismiss,
          s = _ref5$onDismiss === void 0 ? function () {} : _ref5$onDismiss,
          c = _ref5.contentStyles;

      var _i$useState = i.useState(!1),
          _i$useState2 = _slicedToArray(_i$useState, 2),
          f = _i$useState2[0],
          p = _i$useState2[1],
          _i$useState3 = i.useState(null),
          _i$useState4 = _slicedToArray(_i$useState3, 2),
          m = _i$useState4[0],
          g = _i$useState4[1],
          _i$useState5 = i.useState(0),
          _i$useState6 = _slicedToArray(_i$useState5, 2),
          h = _i$useState6[0],
          x = _i$useState6[1],
          _i$useState7 = i.useState(0),
          _i$useState8 = _slicedToArray(_i$useState7, 2),
          y = _i$useState8[0],
          b = _i$useState8[1],
          _i$useState9 = i.useState(0),
          _i$useState10 = _slicedToArray(_i$useState9, 2),
          v = _i$useState10[0],
          w = _i$useState10[1],
          _i$useState11 = i.useState(0),
          _i$useState12 = _slicedToArray(_i$useState11, 2),
          S = _i$useState12[0],
          _ = _i$useState12[1],
          _i$useState13 = i.useState(0),
          _i$useState14 = _slicedToArray(_i$useState13, 2),
          E = _i$useState14[0],
          O = _i$useState14[1],
          _i$useState15 = i.useState(null),
          _i$useState16 = _slicedToArray(_i$useState15, 2),
          P = _i$useState16[0],
          j = _i$useState16[1],
          C = function C() {
        p(!f), f && s();
      };

      i.useEffect(function () {
        if (f && m && m.current) {
          var _e = window.innerWidth,
              _t = window.innerHeight,
              _n = P.offsetHeight,
              _o = m.current,
              _o$getBoundingClientR = _o.getBoundingClientRect(),
              _r = _o$getBoundingClientR.left,
              _i = _o$getBoundingClientR.x,
              _l = _o$getBoundingClientR.y,
              _a = _o$getBoundingClientR.width,
              _s = _o$getBoundingClientR.height,
              _c = _o$getBoundingClientR.top;

          if (w(_r), _r + d > _e) {
            w(_r - (_r + d - _e));
          }

          if (b(_l - u), _c + _n > _t) {
            b(_c - (_c + _n - _t) - 2 * S);
          }

          x(_i), _(_s), O(_a), document.addEventListener("scroll", function () {
            return p(!1);
          }), document.addEventListener("resize", function () {
            return p(!1);
          });
        }

        !f && document.removeEventListener && (document.removeEventListener("scroll", function () {}), document.removeEventListener("resize", function () {}));
      }, [m, f, d, P, S, u]), i.useEffect(function () {
        g(i.default.createRef());
      }, []);
      return i.default.createElement(t.DropdownContainer, {
        className: "lego-dropdown " + l
      }, f && i.default.createElement(t.OverlayButton, {
        onClick: function onClick() {
          return C();
        }
      }), i.default.createElement(t.DropdownButton, {
        ref: m,
        onClick: function onClick() {
          return C();
        }
      }, o && o.constructor === String ? i.default.createElement(t.Title, null, o) : o({
        toggle: C,
        isOpened: f
      }), e && i.default.createElement(t.Indicator, {
        color: n,
        opened: f
      })), i.default.createElement(a.default, {
        rootId: "dropdown-root",
        insertBefore: !0
      }, i.default.createElement(t.Content, {
        id: l + "-content",
        ref: function ref(e) {
          return j(e);
        },
        x: h,
        y: y,
        left: v,
        height: S,
        contentWidth: d,
        width: E,
        opened: f,
        styles: c
      }, r({
        toggle: C,
        isOpened: f
      }))));
    };
  },
  8: function _(e, t) {
    e.exports = require("../Portal/Portal");
  }
});